import { alpha, styled } from '@mui/material';

export const NotificationContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  height: 'fit-content',
  padding: '12px',
  margin: '6px 10px',
  transition: 'background-color 120ms ease',
  border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
  borderRadius: '14px',
  ':hover': {
    backgroundColor: alpha(theme.palette.text.primary, 0.04),
  },
}));

export const ContentWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  fontSize: '13px',
});

export const SubjectSpan = styled('span')(({ theme }) => ({
  fontWeight: 500,
  fontSize: '13px',
  cursor: 'pointer',
  color: theme.palette.text.primary,
  '&:hover': {
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
  },
}));

export const Forwarded = styled('p')(() => ({
  fontStyle: 'italic',
  fontSize: '12px',
}));

export const UserHighlight = styled('span')(() => ({
  fontWeight: 600,
}));

export const DateText = styled('p')(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '12px',
}));

export const ReadIndicator = styled('span')(({ theme }) => ({
  position: 'relative',
  display: 'inline-block',
  width: '10px',
  height: '10px',
  backgroundColor: theme.palette.primary.main,
  borderRadius: '50%',
}));
